import React from 'react';

const AboutPage = () => {
  return (
    <div className="bg-background text-on-surface font-body antialiased min-h-screen pt-24 pb-20">
      <main className="max-w-4xl mx-auto px-8">
        <header className="mb-20">
          <span className="text-primary font-bold tracking-widest uppercase text-sm mb-4 block">Our Story</span>
          <h1 className="text-5xl md:text-7xl font-extrabold tracking-tighter mb-8 font-headline">
            Curating the Soul of <span className="text-primary italic">Bucharest</span>.
          </h1>
          <p className="text-xl md:text-2xl text-on-surface-variant leading-relaxed font-light italic">
            "Local Advisor was born from a simple observation: the best parts of a city aren't found in tourist brochures, but in the shared wisdom of those who live there."
          </p>
        </header>

        <section className="space-y-12">
          <div className="prose prose-lg prose-emerald max-w-none text-on-surface-variant leading-relaxed">
            <p>
              Bucharest is a city of layers. From its "Little Paris" Belle Époque architecture to its complex socialist history and its vibrant modern energy, finding your place here can be an overwhelming journey.
            </p>
            <p>
              We created Local Advisor to be your digital curator. We don't just list places; we tell stories. We don't just post jobs; we build careers. We don't just show houses; we find homes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
            <div className="bg-surface-container-low p-8 rounded-2xl border border-outline-variant/10">
              <h3 className="text-xl font-bold mb-4">Our Mission</h3>
              <p className="text-on-surface-variant text-sm leading-relaxed">
                To empower locals and new residents alike with curated, high-quality information that fosters community connection and sustainable urban living.
              </p>
            </div>
            <div className="bg-surface-container-low p-8 rounded-2xl border border-outline-variant/10">
              <h3 className="text-xl font-bold mb-4">The Community</h3>
              <p className="text-on-surface-variant text-sm leading-relaxed">
                Every recommendation and listing is vetted by our local experts. We believe in quality over quantity, ensuring that your time is spent in the spaces that truly matter.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AboutPage;
